import styles from "./Form.module.css";
import mail_icon from "../assets/mail_icon.png";
import { useState, useEffect } from "react";
import { Tips } from "./Tips";

type Props = {
  isOpen: boolean;
  date: string;
  onPressRegist: (mail: string) => void;
  error: string;
  showTips: boolean;
  onCloseTips: () => void;
  variant?: "default" | "light";
};

export const Form = (props: Props) => {
  const [email, setEmail] = useState("");
  const [isMounted, setIsMounted] = useState(props.showTips);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (props.showTips) {
      setIsMounted(true);
      // 次のフレームでopacityを1にする
      requestAnimationFrame(() => {
        setIsVisible(true);
      });
    } else {
      setIsVisible(false);
      // トランジション完了後にDOMから削除
      const timer = setTimeout(() => {
        setIsMounted(false);
      }, 150); // 0.15s
      return () => clearTimeout(timer);
    }
  }, [props.showTips]);

  return (
    <div className={`${styles.container} ${props.variant === "light" ? styles.containerLight : ""}`}>
      {/* Tipsをフォーム上部に重ねて表示 */}
      {isMounted && (
        <div
          className={styles.tipsOverlay}
          onClick={props.onCloseTips}
          style={{ cursor: "pointer", opacity: isVisible ? 1 : 0 }}
        >
          <Tips
            body={
              props.isOpen
                ? "If you are considering a commission, please register your email address. An email containing the URL for the request form will be sent to you."
                : "If you are considering a commission, please register your email address. When commissions are accepted again, you will receive an email containing the URL for the request form."
            }
          />
        </div>
      )}
      <div className={styles.content}>
        <div
          className={styles.icon}
          style={{ backgroundImage: `url(${mail_icon})` }}
        />
        <div className={styles.notice}>
          {!props.isOpen ? (
            <>
              <div className={styles.title}>
                Receive an email when commissions resume
              </div>
              <div className={styles.subTitle}>
                <div className={styles.text}>Scheduled to resume</div>
                <div className={styles.date}>{props.date}</div>
              </div>
            </>
          ) : (
            <>
              <div className={styles.title}>Apply for a commission</div>
              <div className={styles.subTitle}>
                <div className={styles.date}>
                  A link to the request form will be sent to the email address
                  you entered.
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className={styles.form}>
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          className={styles.input}
          placeholder="your e-mail adress"
        />
        <div
          className={styles.button}
          onClick={() => props.onPressRegist(email)}
        >
          regist
        </div>
      </div>
      <div>{props.error}</div>
    </div>
  );
};
